// TODO: Extract this to shared

export interface Attribute {
  name: string;
}

export interface AttributeCollection {
  attributeType: number;
  collectionName: string;
  attributes: Attribute[];
}

export interface AttributesResponse {
  attributes: AttributeCollection[];
}

export enum AttributeType {
  Allergen = 1,
  CaptureMethod = 2,
  Category = 3,
  Certification = 4,
  CountryOfOrigin = 5,
  DietaryAndLifestyle = 6,
  Family = 7,
  Flavour = 8,
  Packaging = 9,
  Production = 10,
  Storage = 12,
  Ingredients = 13,
}

export function getAttributesByEnum(attributeType: AttributeType): string {
  const attributeMap: Record<AttributeType, string> = {
    [AttributeType.Allergen]: 'allergens',
    [AttributeType.CaptureMethod]: 'captureMethod',
    [AttributeType.Category]: 'categories',
    [AttributeType.Certification]: 'certifications',
    [AttributeType.CountryOfOrigin]: 'countryOfOrigin',
    [AttributeType.DietaryAndLifestyle]: 'dietaryLifestyles',
    [AttributeType.Family]: 'family',
    [AttributeType.Flavour]: 'flavours',
    [AttributeType.Packaging]: 'packagingTypes',
    [AttributeType.Production]: 'productionMethods',
    [AttributeType.Storage]: 'storageMethods',
    [AttributeType.Ingredients]: 'ingredients',
  };

  return attributeMap[attributeType] || '';
}
export function getAttributeTypeLabel(attributeType: AttributeType): string {
  const labelMap: Record<AttributeType, string> = {
    [AttributeType.Allergen]: 'Made Without',
    [AttributeType.CaptureMethod]: 'Capture Method',
    [AttributeType.Category]: 'Category',
    [AttributeType.Certification]: 'Certification',
    [AttributeType.CountryOfOrigin]: 'Country of Origin',
    [AttributeType.DietaryAndLifestyle]: 'Dietary and Lifestyle',
    [AttributeType.Family]: 'Family',
    [AttributeType.Flavour]: 'Flavour',
    [AttributeType.Packaging]: 'Packaging',
    [AttributeType.Production]: 'Production',
    [AttributeType.Storage]: 'Storage',
    [AttributeType.Ingredients]: 'Ingredients',
  };

  return labelMap[attributeType] || '';
}
